import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/play.svg'


const _withScopeId = n => (_pushScopeId("data-v-196428fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-item" }
const _hoisted_2 = {
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}, null, -1))
const _hoisted_4 = {
  key: 3,
  class: "reshare-indicator"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-share" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "file-item-author"
}
const _hoisted_8 = { class: "item-wrapper" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "item-author-info"
}
const _hoisted_11 = {
  key: 0,
  class: "name"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "checker checked"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "checker unchecked"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_small_loader = _resolveComponent("app-small-loader")!
  const _component_app_video_player = _resolveComponent("app-video-player")!
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_app_question_pop_up = _resolveComponent("app-question-pop-up")!
  const _component_mixed_media_pop_up = _resolveComponent("mixed-media-pop-up")!
  const _component_app_rename_file = _resolveComponent("app-rename-file")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "video-item",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openFile && _ctx.openFile(...args)))
    }, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectVideo(_ctx.file))),
        class: _normalizeClass({
          'file-item-wrapper': _ctx.columnView,
          'video-item-grid': (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID || _ctx.driveStore.isGridFolderView)
        })
      }, [
        _createElementVNode("div", _hoisted_1, [
          (!_ctx.thumbnail)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.isReady)
                  ? (_openBlock(), _createBlock(_component_app_small_loader, {
                      key: 0,
                      class: "spinner",
                      size: _ctx.columnView ? 14 : 32
                    }, null, 8, ["size"]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
                  [_vShow, _ctx.isReady && !_ctx.hidePlay]
                ]),
                _withDirectives(_createVNode(_component_app_video_player, {
                  url: _ctx.videUrl,
                  controls: false,
                  onLoadedmetadata: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isReady = true))
                }, null, 8, ["url"]), [
                  [_vShow, _ctx.isReady]
                ])
              ], 64))
            : (_openBlock(), _createBlock(_component_app_lazy_image, {
                key: 1,
                url: _ctx.thumbUrl
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["url"])),
          (!!_ctx.file.share && !_ctx.isNetwork)
            ? (_openBlock(), _createElementBlock("i", {
                key: 2,
                class: _normalizeClass(["icon icon-users", { 'file-item-shared': _ctx.columnView }])
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.reshareAllowed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.showTitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.file.name), 1))
                  : _createCommentVNode("", true),
                (_ctx.isNetwork)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_ctx.columnView && !_ctx.mainStore.isMobile)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.authorName), 1))
                        : _createCommentVNode("", true),
                      (_ctx.photoUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "photo",
                            src: _ctx.photoUrl
                          }, null, 8, _hoisted_12))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isNetwork || _ctx.columnView)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isMediaSettingsPopUp = true), ["prevent","stop"])),
                    class: "icon icon-dots file-item-option"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.selector)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.file.selected || _ctx.isSelectedFromParent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                : (_openBlock(), _createElementBlock("div", _hoisted_16))
            ], 64))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.isQuestionPopUp)
        ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
            key: 0,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isQuestionPopUp = false)),
            onDelete: _ctx.deleteFile
          }, null, 8, ["onDelete"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isMediaSettingsPopUp)
      ? (_openBlock(), _createBlock(_component_mixed_media_pop_up, {
          key: 0,
          file: _ctx.file,
          onClosePopUp: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isMediaSettingsPopUp = false)),
          onOpenFileRename: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fileRenamePopUp = true))
        }, null, 8, ["file"]))
      : _createCommentVNode("", true),
    (_ctx.fileRenamePopUp)
      ? (_openBlock(), _createBlock(_component_app_rename_file, {
          key: 1,
          file: _ctx.file,
          "mount-error-info": _ctx.renameMountErrorInfo,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fileRenamePopUp = false)),
          onClearMountErrorInfo: _cache[8] || (_cache[8] = ($event: any) => (_ctx.renameMountErrorInfo = undefined))
        }, null, 8, ["file", "mount-error-info"]))
      : _createCommentVNode("", true)
  ], 64))
}